import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { capitalizeWords } from 'src/utilities/textHelper';
import { StoreContext } from 'src/stores/mobx/RootStore';

const CalendarEvent = (props) => {
  const calendarStore = useContext(StoreContext).calendar;
  const { event } = props;
  const shortTitle = calendarStore.current_view === 'month';
  const isAgendaView = calendarStore.current_view === 'agenda';

  const klassIcon = (event) => {
    if (!event.element_klass_name) { return null; }

    return event.element_klass_name;
  }

  const eventKind = (event) => {
    if (!event.kind) { return null; }

    return `${capitalizeWords(event.kind)}`;
  }

  const eventDetail = (event) => {
    if (shortTitle) { return null; }

    let detail = eventKind(event);
    if (event.element_klass_name) {
      detail = (
        <span className="d-block my-2">
          {klassIcon(event)}
          {eventKind(event)}
        </span>
      );
    }
    return detail;
  }

  if (isAgendaView) {
    const titleStyle = {
      fontSize: '1rem',
      fontWeight: 'bold',
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical'
    };
    return (
      <div style={titleStyle}>
        {event.element_klass_icon && (
          <i className={`${event.element_klass_icon} me-2`} />
        )}
        {event.title}
      </div>
    );
  }

  return (
    <div className={`${shortTitle ? 'my-2' : 'my-0'} mt-1 fw-bold text-capitalize`} style={{ fontSize: '0.75rem' }}>
      <p className="mb-1" style={{ overflow: 'hidden', textOverflow: 'clip', whiteSpace: 'nowrap' }}>
        {event.element_klass_icon && <i className={`${event.element_klass_icon} me-1`} />}
        {event.title}
      </p>
      {!shortTitle && (
        <span className="d-block fw-normal" style={{ fontSize: '0.70rem' }}>
          {eventDetail(event)}
          {event.element_short_label}
        </span>
      )}
    </div>
  );
}

export default CalendarEvent;

CalendarEvent.propTypes = {
  event: PropTypes.shape({
    title: PropTypes.string,
    kind: PropTypes.string,
    description: PropTypes.string,
    element_klass_icon: PropTypes.string,
    element_klass_name: PropTypes.string,
    element_short_label: PropTypes.string,
  }).isRequired,
};
